import { useMutation } from '@tanstack/react-query'
import { placeOrderUpsellOffers } from '../services'
import { useUpsellStore } from '@/store/upsell'
import { useRouter } from 'next/navigation'

export const useSubmitOffers = (data: IOfferOrderResponse | undefined) => {
  const { orderCode, clearOrderCode } = useUpsellStore()
  const router = useRouter()
  const { mutate: placeOrderUpsellOffersMutation, isPending } = useMutation({
    mutationKey: ['SET_ORDER_CODE_UPSELL'],
    mutationFn: ({ orderCode, selectedOffers }: { orderCode: string; selectedOffers: string[] }) => {
      return placeOrderUpsellOffers({ order_id: Number(orderCode), selected_offers: selectedOffers })
    },
    onSuccess: (data) => {
      clearOrderCode()
      router.push('/payment' + '?order=' + data?.data?.orderV2?.order_number)
    },
  })
  const handleSubmit = () => {
    if (!data || !orderCode) return
    const selectedOffers = data?.offers?.map((offer) => offer?.offer_id) || []
    placeOrderUpsellOffersMutation({ orderCode, selectedOffers })
  }
  return { handleSubmit, isPending }
}
